<template>
  <div class="terms__content">
    <p>{{$t('privacy.firstPart.text[0]')}}</p>

    <p>
      {{$t('privacy.firstPart.text[1]')}}
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
    </p>

    <p>{{$t('privacy.firstPart.text[2]')}}</p>

    <p>{{$t('privacy.firstPart.text[3]')}}</p>

    <p class="no-margin">{{$t('privacy.firstPart.clarification[0]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[1]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[2]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[3]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[4]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[5]')}}</p>
    <p class="no-margin">{{$t('privacy.firstPart.clarification[6]')}}</p>

    <p>{{$t('privacy.firstPart.text[4]')}}</p>

    <p>{{$t('privacy.firstPart.text[5]')}}
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.</p>

    <p>{{$t('privacy.firstPart.text[6]')}}</p>

    <p>{{$t('privacy.firstPart.text[7]')}}</p>

    <h3>{{ $t('privacy.list[0].title') }}</h3>
    <p>{{ $t('privacy.list[0].text[0]') }}</p>
    <p>{{ $t('privacy.list[0].text[1]') }}</p>
    <p>{{ $t('privacy.list[0].text[2]') }}</p>
    <p>{{ $t('privacy.list[0].text[3]') }}</p>
    <p>{{ $t('privacy.list[0].text[4]') }}</p>
    <p>{{ $t('privacy.list[0].text[5]') }}</p>
    <p>{{ $t('privacy.list[0].text[6]') }}</p>
    <p>{{ $t('privacy.list[0].text[7]') }}</p>
    <p>{{ $t('privacy.list[0].text[8]') }}</p>
    <p>{{ $t('privacy.list[0].text[9]') }}</p>
    <p>{{ $t('privacy.list[0].text[10]') }}</p>
    <p>{{ $t('privacy.list[0].text[11]') }}</p>
    <p>{{ $t('privacy.list[0].text[12]') }}</p>

    <h3>{{ $t('privacy.list[1].title') }}</h3>
    <p>{{ $t('privacy.list[1].text[0]') }}</p>
    <p>{{ $t('privacy.list[1].text[1]') }}</p>
    <p>{{ $t('privacy.list[1].text[2]') }}</p>
    <p>{{ $t('privacy.list[1].text[3]') }}</p>
    <p>{{ $t('privacy.list[1].text[4]') }}</p>
    <p>{{ $t('privacy.list[1].text[5]') }}</p>

    <h3>{{ $t('privacy.list[2].title') }}</h3>
    <p>{{ $t('privacy.list[2].text[0]') }}</p>

    <p class="no-margin">{{ $t('privacy.list[2].clarification[0]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[2].clarification[1]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[2].clarification[2]') }}</p>

    <p>{{ $t('privacy.list[2].text[1]') }}</p>
    <p>{{ $t('privacy.list[2].text[2]') }}</p>
    <p>{{ $t('privacy.list[2].text[3]') }}</p>

    <h3>{{ $t('privacy.list[3].title') }}</h3>
    <p>{{ $t('privacy.list[3].text[0]') }}</p>
    <p>{{ $t('privacy.list[3].text[1]') }}</p>
    <p>{{ $t('privacy.list[3].text[2]') }}</p>
    <p>{{ $t('privacy.list[3].text[3]') }}</p>
    <p>{{ $t('privacy.list[3].text[4]') }}</p>
    <p>{{ $t('privacy.list[3].text[5]') }}</p>

    <h3>{{ $t('privacy.list[4].title') }}</h3>
    <p>{{ $t('privacy.list[4].text[0]') }}</p>

    <p class="no-margin">{{ $t('privacy.list[4].clarification[0]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[1]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[2]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[3]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[4]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[5]') }}</p>
    <p class="no-margin">{{ $t('privacy.list[4].clarification[6]') }}</p>

    <h3>{{ $t('privacy.list[5].title') }}</h3>
    <p>{{ $t('privacy.list[5].text[0]') }}</p>
    <p>{{ $t('privacy.list[5].text[1]') }}</p>

    <p>{{ $t('privacy.list[5].clarification[0]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[1]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[2]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[3]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[4]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[5]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[6]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[7]') }}</p>
    <p>{{ $t('privacy.list[5].clarification[8]') }}</p>

    <p>{{ $t('privacy.list[5].text[2]') }}</p>
    <p>{{ $t('privacy.list[5].text[3]') }}</p>
    <p>{{ $t('privacy.list[5].text[4]') }}</p>
    <p>{{ $t('privacy.list[5].text[5]') }}</p>
    <p>{{ $t('privacy.list[5].text[6]') }}</p>
    <p>{{ $t('privacy.list[5].text[7]') }}</p>
    <p>{{ $t('privacy.list[5].text[8]') }}</p>
    <p>{{ $t('privacy.list[5].text[9]') }}</p>
    <p>{{ $t('privacy.list[5].text[10]') }}</p>
    <p>{{ $t('privacy.list[5].text[11]') }}</p>
    <p>{{ $t('privacy.list[5].text[12]') }}</p>
    <p>{{ $t('privacy.list[5].text[13]', {supportEmail}) }}</p>


    <h3>{{ $t('privacy.list[6].title') }}</h3>
    <p>{{ $t('privacy.list[6].text[0]') }}</p>
    <p>{{ $t('privacy.list[6].text[1]') }}</p>


    <h3>{{ $t('privacy.list[7].title') }}</h3>
    <p>{{ $t('privacy.list[7].text[0]') }}</p>
    <p>{{ $t('privacy.list[7].clarification[0]') }}</p>
    <p>{{ $t('privacy.list[7].clarification[1]') }}</p>

    <h3>{{ $t('privacy.list[8].title') }}</h3>
    <p>{{ $t('privacy.list[8].text[0]') }}</p>
    <p>{{ $t('privacy.list[8].text[1]') }}</p>

    <p>{{ $t('privacy.list[8].clarification[0]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[1]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[2]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[3]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[4]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[5]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[6]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[7]') }}</p>
    <p>{{ $t('privacy.list[8].clarification[8]') }}</p>

    <h3>{{ $t('privacy.list[9].title') }}</h3>
    <p>{{ $t('privacy.list[9].text[0]') }}</p>
    <p>{{ $t('privacy.list[9].text[1]') }}</p>
    <p>{{ $t('privacy.list[9].text[2]') }}</p>

    <h3>{{ $t('privacy.list[10].title') }}</h3>
    <p>{{ $t('privacy.list[10].text[0]') }}</p>

    <h3>{{ $t('privacy.list[11].title') }}</h3>
    <p>{{ $t('privacy.list[11].text[0]') }}</p>
    <p>{{ $t('privacy.list[11].text[1]') }}</p>

    <h3>{{ $t('privacy.list[12].title') }}</h3>
    <p>{{ $t('privacy.list[12].text[0]') }}</p>

    <h3>{{ $t('privacy.list[13].title') }}</h3>
    <p>{{ $t('privacy.list[13].text[0]') }}</p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      supportEmail: 'support@' + location.hostname,
    }
  },
}
</script>

<style scoped>

</style>
